import commentAxios from 'api/commentsAxios'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button } from 'react-bootstrap'
import moment from 'moment'

const TableWrapper = styled.div`
  .blue,
  th {
    color: #3985b9;
    user-select: none;
  }
  .pointer {
    cursor: pointer;
  }
  button {
    user-select: none;
  }
  table {
    margin: 0;
    margin-bottom: 10px;
  }
`

const Main = styled.div`
  .select-sort {
    width: fit-content;
    padding: 0 1.5rem;
    label {
      margin-bottom: 8px;
    }
    select {
      padding: 6px;
    }
  }
`

const ReportUserTable = ({ sk, pk }) => {
  const [sortConfig, setSortConfig] = useState({
    lastKey: null,
    loadMore: false
  })
  const [data, setData] = useState([])
  const [lastKey, setLastKey] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(
    async ({ lastKey, loadMore = false }) => {
      try {
        setLoading(true)
        const res = await commentAxios.post('/admin/reports', {
          sk,
          pk,
          limit: 10,
          last_evaluated_key: lastKey
        })
        const data = res.data?.users || []
        setData((state) => {
          if (loadMore) {
            return [...state, ...data]
          }
          return data
        })
        setLastKey(res?.data?.lastEvaluatedKey)
      } catch (err) {
        console.log(err)
        setData([])
      } finally {
        setLoading(false)
      }
    },
    [sk, pk]
  )

  useEffect(() => {
    fetchData(sortConfig)
  }, [fetchData, sortConfig])

  const handlePagination = () => {
    setSortConfig((prev) => ({
      ...prev,
      lastKey,
      loadMore: true
    }))
  }

  return (
    <Main>
      <TableWrapper>
        <table className='table table-bordered table-striped'>
          <thead className='table-light'>
            <tr>
              <th role='button'>Name</th>
              <th>Email</th>
              <th role='button'>Reported On</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <Fragment key={index}>
                <tr key={index}>
                  <td>{row.name}</td>
                  <td>{row.email}</td>
                  <td>
                    {moment(row.reportedAt).local().format('MM/DD/YYYY HH:mm')}
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>
        <div className='text-left my-3'>
          <Button
            classID='load-more'
            variant='primary'
            onClick={handlePagination}
            disabled={!Boolean(lastKey) || loading}
          >
            {loading
              ? 'Loading...'
              : Boolean(lastKey)
              ? 'Load More'
              : 'No More Items'}
          </Button>
        </div>
      </TableWrapper>
    </Main>
  )
}

export default ReportUserTable
